<template>
    <sidebar :data="data"
             logo-url=""
             logo-src=""
             logo-icon-src=""
    />
</template>

<script>
import {urlGenerator} from "../../../Helpers/AxiosHelper";

export default {
    name: 'DashboardSidebar',
    props: {
        data: {
            required: true
        },
        logo: {
            type: String,
        },
        logoIcon: {
            type: String,
        }
    },
    data() {
        return {
            urlGenerator,
        }
    }
}
</script>
